/**
 * @generated SignedSource<<ec78b03adb12131e59354a60ef390a60>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "RecurringCreditCard",
    "kind": "LinkedField",
    "name": "recurringCreditCards",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cardNumber",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "token",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "PayWithWalletAndCardModalContentQuery",
    "selections": (v0/*: any*/),
    "type": "ClientAppQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "PayWithWalletAndCardModalContentQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "1c5cdabdcacc9994f41e63ac2b753e29",
    "id": null,
    "metadata": {},
    "name": "PayWithWalletAndCardModalContentQuery",
    "operationKind": "query",
    "text": "query PayWithWalletAndCardModalContentQuery {\n  recurringCreditCards {\n    cardNumber\n    token\n  }\n}\n"
  }
};
})();

node.hash = "f1d0063fafb457074ebef9be4c6090f3";

module.exports = node;
